import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    position: 'relative',
    backgroundColor: theme.palette.grey[100],

    '&:hover': {
      '& > button': {
        visibility: 'visible',
      },
    },
    '& .MuiCard-root': {
      overflow: 'visible',
    },
  },
  star: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(-1),
    backgroundColor: theme.palette.common.white,
    zIndex: 1,

    '&:hover': {
      backgroundColor: theme.palette.common.white,
    },
  },
}));
